import React, { useState } from 'react';
import { ReactComponent as IconLeft } from "@assets/Icons/ArrowLeft.svg";
import GenericButton from '@ui-components/Button/GenericButton';
import { ReactComponent as ChevronDownSvg } from "@assets/Icons/IconChevron-Down.svg";

export interface AdminSection {
  label: string;
  route?: string;
  id?: string;
  children?: AdminSection[];
}
interface AdminCenterMenuProps {
  onBack: () => void;
  onSectionClick: (route: string) => void;
  activePath: string;
  sections:  AdminSection[];
}

export default function AdminCenterMenu({ onBack, onSectionClick, activePath, sections }: AdminCenterMenuProps) {
  const [expanded, setExpanded] = useState<Record<string,boolean>>({});
  function toggle(label: string) {
    setExpanded(prev => ({ ...prev, [label]: !prev[label] }));
  }
  function renderList(items: AdminSection[]) {
    return (
      <ul>
        {items.map(item => {
          const isActive = 
            item.route
              ? activePath === item.route ||
                activePath.startsWith(item.route + "/")
              : false;
  
          return (
            <li key={item.id ?? item.label}>
              <div
                className={`
                  flex justify-between items-center px-2 py-2 rounded cursor-pointer
                  ${isActive 
                    ? "bg-semantic-state-active text-semantic-text-brand" 
                    : "hover:bg-semantic-state-active hover:text-semantic-text-brand text-semantic-text-secondary"
                  }
                `}
                onClick={() => {
                  if (item.children) {
                    toggle(item.label);
                  } else if (item.route) {
                    onSectionClick(item.route);
                  }
                }}
              >
                <span>{item.label}</span>
  
                {item.children && (
                  <button onClick={e => { e.stopPropagation(); toggle(item.label) }}>
                    <ChevronDownSvg
                      className={`h-4 w-4 transition-transform ${
                        expanded[item.label] ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                )}
              </div>
  
              {item.children && expanded[item.label] && (
                <div className="ml-4">
                  {renderList(item.children)}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    );
  }
  
  return (
    <div className="flex flex-col h-full bg-semantic-bg-primary">
      <div className="w-full px-4 pt-4">
        <GenericButton
          label="Back"
          variant="secondary"
          shape='ghost'
          size="sm"
          className="w-full justify-start items-center flex text-semantic-text-secondary"
          onClick={onBack}
          icon={<IconLeft className="w-5 h-5" />}
          iconPosition="left"
        />
      </div>
      <hr className="my-4 border-gray-200" />
      <div className="flex-1 px-2 py-2 overflow-auto">
        {renderList(sections)}
      </div>
    </div>
  );
} 